import { isGroup } from "@medoma/models/activities";
import {
  selectedItemTypeSchema,
  useSelection,
} from "../Selection/SelectionContext";
import { Group } from "@/pages/commandcenter/Patients/Patient/Activities/Group/Group";
import { ActivityOccurrence } from "@/pages/commandcenter/Patients/Patient/Activities/ActivityOccurrence/ActivityOccurrence";
import { CloseButton } from "@/components/NavigationButtons/NavigationButtons";

const VisitDetailsPanel = ({ visitId }: { visitId: string }) => {
  const { clearSelection } = useSelection();

  return (
    <Group
      key={visitId}
      groupId={visitId}
      closeGroupPanel={clearSelection}
      navigationButtonsInHeader={{
        closeButton: <CloseButton close={clearSelection} />,
      }}
    />
  );
};

const ActivityOccurrencePanel = ({
  activityId,
  occurrenceId,
}: {
  activityId: string;
  occurrenceId: string;
}) => {
  const { clearSelection } = useSelection();

  return (
    <ActivityOccurrence
      key={`${activityId}-${occurrenceId}`}
      activityId={activityId}
      occurrenceId={occurrenceId}
      closeActivityOccurrencePanel={clearSelection}
      navigationButtonsInHeader={{
        closeButton: <CloseButton close={clearSelection} />,
      }}
    />
  );
};

export const DetailsPanel = () => {
  const { selectedItem } = useSelection();

  if (!selectedItem) {
    return null;
  }

  // Route details are not supported yet (should be though)
  if (selectedItem.type === selectedItemTypeSchema.enum.plannedRoute) {
    return null;
  }

  if (selectedItem.type === selectedItemTypeSchema.enum.plannedVisit) {
    return (
      <VisitDetailsPanel
        key={selectedItem.item.id}
        visitId={selectedItem.item.id}
      />
    );
  }

  if (
    selectedItem.type ===
    selectedItemTypeSchema.enum.plannedActivityOccurrenceOrGroup
  ) {
    if (isGroup(selectedItem.item)) {
      return (
        <VisitDetailsPanel
          key={selectedItem.item.id}
          visitId={selectedItem.item.id}
        />
      );
    }
    return (
      <ActivityOccurrencePanel
        key={selectedItem.item.id}
        activityId={selectedItem.item.activityId}
        occurrenceId={selectedItem.item.id}
      />
    );
  }

  if (selectedItem.type === selectedItemTypeSchema.enum.itemToPlan) {
    const item = selectedItem.item;
    if (isGroup(item)) {
      return <VisitDetailsPanel key={item.id} visitId={item.id} />;
    }
    return (
      <ActivityOccurrencePanel
        key={item.id}
        activityId={item.activityId}
        occurrenceId={item.id}
      />
    );
  }

  return null;
};
